<!-- Componente de Registros Duplicados (cuando está activo) -->
<div *ngIf="mostrarRegistrosDuplicados">
  <app-registros-duplicados 
    [mostrarComoSubcomponente]="true"
    (volverADeclaracion)="volverADeclaracion()">
  </app-registros-duplicados>
</div>

<!-- Contenido completo de Ver Declaración (cuando no está en registros duplicados) -->
<div *ngIf="!mostrarRegistrosDuplicados">
  
  <!-- begin breadcrumb -->
  <ol class="breadcrumb pull-right">
    <li class="breadcrumb-item"><a [routerLink]="['/inicio']">Inicio</a></li>
    <li class="breadcrumb-item">{{descripcion}}</li>
    <li class="breadcrumb-item active">{{ titulo }}</li>
  </ol>
  <!-- end breadcrumb -->

  <!-- begin page-header -->
  <h1 class="page-header"> <i class="fa fa-search"></i> {{ titulo }} <small> {{ descripcion }}</small></h1>
  <!-- end page-header -->

  <!-- begin row -->
  <div class="row">
    <div class="col-md-12">
      <div class="panel panel-iatuch">
        <!-- begin panel-heading -->
        <div class="panel-heading ui-sortable-handle">
          <div class="panel-heading-btn"></div>
          <h4 class="panel-title">
            <i class="fas fa-list fa-fw"></i> Resultado
          </h4>
        </div>
        <!-- end panel-heading -->
        
        <!-- begin panel-body -->
        <div class="panel-body">
          
          <!-- Controles principales -->
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="d-flex justify-content-between align-items-center flex-wrap">
                <!-- Botones de tipo de declaración -->
                <div class="btn-group mb-2 shadow-sm">
                  <button id="bt_ing_gas" class="bt_tipo_declaracion btn btn-outline-success btn-sm" 
                          [class.active]="tipo_dec == 'ing_gas'" 
                          [class.btn-success]="tipo_dec == 'ing_gas'"
                          [class.text-white]="tipo_dec == 'ing_gas'"
                          (click)="tipo_declaracion('ing_gas')">
                    <i class="fas fa-chart-line mr-2"></i>Ingresos y Gastos
                  </button>
                  <button id="bt_excenciones" class="bt_tipo_declaracion btn btn-outline-success btn-sm"
                          [class.active]="tipo_dec == 'exenciones'" 
                          [class.btn-success]="tipo_dec == 'exenciones'"
                          [class.text-white]="tipo_dec == 'exenciones'"
                          (click)="tipo_declaracion('exenciones')">
                    <i class="fas fa-shield-alt mr-2"></i>Exenciones
                  </button>
                  <button id="bt_bien_raiz" class="bt_tipo_declaracion btn btn-outline-success btn-sm"
                          [class.active]="tipo_dec == 'bien_raiz'" 
                          [class.btn-success]="tipo_dec == 'bien_raiz'"
                          [class.text-white]="tipo_dec == 'bien_raiz'"
                          (click)="tipo_declaracion('bien_raiz')">
                    <i class="fas fa-home mr-2"></i>Bien Raíz
                  </button>
                </div>
                
                <!-- Controles de descarga -->
                <div class="d-flex align-items-center flex-wrap" *ngIf="descarga_txt == true">
                  <!--<div class="switcher mr-3 mb-2">
                    <label for="switcher_checkbox_1" class="mb-0">Rectificar</label>
                    <input type="checkbox" (click)="rectificar()" name="rectificacion" 
                           id="switcher_checkbox_1" value="1" #rectificacion="ngModel" 
                           [(ngModel)]="parametros_importador.rectificacion">
                  </div>-->
                  
                  <div class="d-flex align-items-center mr-3 mb-2" *ngIf="parametros_importador.rectificacion == true">
                    <label class="mb-0 mr-2">N°</label>
                    <input class="form-control form-control-sm" style="width: 80px;"
                           [class.is-invalid]="parametros_importador.rectificacion == true && parametros_importador.num_rectificacion == ''"
                           type="text" #num_rectificacion name="num_rectificacion" #num_rectificacion="ngModel"
                           [(ngModel)]="parametros_importador.num_rectificacion" required autofocus />
                  </div>
                  
                  <div class="btn-group mb-2" ngbDropdown>
                    <a href="javascript:;" class="btn btn-primary btn-sm dropdown-toggle" ngbDropdownToggle>
                      <i class="fas fa-download fa-fw"></i> Descargar <b class="caret"></b>
                    </a>
                    <div class="dropdown-menu" ngbDropdownMenu>
                      <a href="javascript:;" class="dropdown-item" (click)="downloadCsv()">Importador de Datos (.csv)</a>
                      <a href="javascript:;" class="dropdown-item" (click)="downloadExcelDetail()">
                        <i class="fas fa-file-excel mr-2"></i>Detalle de Datos (.xlsx)
                      </a>
                      <div class="dropdown-divider" *ngIf="csv_thomson_reuters"></div>
                      <a href="javascript:;" class="dropdown-item" 
                         (click)="downloadDjThomsonReuters('csv-seccion-b')" 
                         *ngIf="csv_thomson_reuters">
                        <i class="fas fa-chart-bar mr-2"></i>Thomson Reuters - Sección B (.csv)
                      </a>
                      <a href="javascript:;" class="dropdown-item" 
                         (click)="downloadDjThomsonReuters('csv-seccion-c')" 
                         *ngIf="csv_thomson_reuters">
                        <i class="fas fa-shield-alt mr-2"></i>Thomson Reuters - Sección C (.csv)
                      </a>
                      <a href="javascript:;" class="dropdown-item" 
                         (click)="downloadDjThomsonReuters('csv-seccion-d')" 
                         *ngIf="csv_thomson_reuters">
                        <i class="fas fa-home mr-2"></i>Thomson Reuters - Sección D (.csv)
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Mensaje de error para rectificación -->
              <div class="row" *ngIf="parametros_importador.rectificacion == true && parametros_importador.num_rectificacion == ''">
                <div class="col-12">
                  <small class="text-danger">{{mensaje_num_rectificacion}}</small>
                </div>
              </div>
            </div>
          </div>

          <!-- Contenido de tablas -->
          <div>
            <div class="p-0">
              
              <!-- Alerta para registros duplicados -->
              <div *ngIf="hayRegistrosDuplicados && djOpcionEntidad?.validaciones?.ver_duplicados" class="alert alert-danger alert-danger-border mb-0 rounded-0 border-0 py-2 px-3"> 
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <i class="fas fa-exclamation-triangle text-danger mr-2"></i>
                    <span class="mb-0">
                      Se encontraron <strong>{{cantidadRegistrosDuplicados}} registros duplicados</strong> en las declaraciones del período.
                    </span>
                  </div>
                  <button class="btn btn-danger btn-xs ml-3" 
                          (click)="verRegistrosDuplicados()"
                          ngbTooltip="Ver y corregir registros duplicados">
                    <i class="fas fa-clone mr-1"></i>
                    <span>Ver</span>
                  </button>
                </div>
              </div>
              
              <!-- Alerta para ingresos/gastos -->
              <div *ngIf="tipo == 101 && tipo_dec == 'ing_gas'" class="alert alert-warning alert-warning-border mb-0 rounded-0 border-0 py-2 px-3"> 
                <div class="d-flex align-items-center">
                  <i class="fas fa-info-circle text-warning mr-2"></i>
                  <span class="mb-0">
                    Búsqueda configurada en <strong>Tipo 101 (Ingreso)</strong>. 
                    Para egresos, seleccione <strong>201 - Egreso en Dinero</strong>.
                  </span>
                </div>
              </div>
              
              <!-- Controles específicos para ingresos/gastos -->
              <div *ngIf="tipo_dec == 'ing_gas'" class="px-4 py-3">
                <div class="row align-items-center">
                  <div class="col-md-8">
                    <div class="d-flex align-items-center">
                      <label class="mb-0 mr-3 font-weight-600 text-dark">Tipo:</label>
                      <div class="input-group" style="width: 300px;">
                        <div class="input-group-prepend">
                          <span class="input-group-text bg-white" style="border: 1px solid #dee2e6;">
                            <i class="fas" [ngClass]="tipo < 200 ? 'fa-plus-circle text-success' : 'fa-minus-circle text-danger'"></i>
                          </span>
                        </div>
                        <select class="form-control" style="border: 1px solid #dee2e6; border-left: none;" [(ngModel)]="tipo" (change)="selTipoIngEgr(tipo)">
                          <option value="101">101 - Ingreso en Dinero</option>
                          <option value="201">201 - Egreso en Dinero</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <app-page-size-selector
                      [pageSize]="page_info.n_per_page"
                      [pageSizeOptions]="[15, 25, 50, 100]"
                      (pageSizeChange)="onPageSizeChange($event)">
                    </app-page-size-selector>
                  </div>
                </div>
              </div>
              
              <!-- Tabla de ingresos/gastos -->
              <div *ngIf="tipo_dec == 'ing_gas'">
                
                <!-- Loading para ingresos/gastos (sin scroll) -->
                <div *ngIf="cargando_ingresos" class="border-top border-bottom d-flex flex-column align-items-center justify-content-center" style="height: 500px;">
                  <div class="text-center mb-3">
                    <h5 class="text-primary mb-2 font-weight-normal">Consultando {{ tipo < 200 ? 'Ingresos' : 'Egresos' }}</h5>
                    <p class="text-muted mb-0 small">Analizando declaraciones del período...</p>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <div *ngFor="let dot of [1,2,3]; let i = index" 
                         class="pulse-dot pulse-dot-{{dot}} bg-primary rounded-circle"
                         [class.mx-2]="i === 1">
                    </div>
                  </div>
                </div>

                <!-- Contenido de la tabla (con scroll) -->
                <div *ngIf="!cargando_ingresos" class="border-top border-bottom position-relative" style="max-height: 500px; overflow-y: auto;">
                  <!-- Tabla cuando no está cargando -->
                  <table id="ingresos_gastos" class="table table-sm table-hover mb-0">
                    <thead style="position: sticky; top: 0; border-bottom: 1px; border-color: black; background: rgb(255, 255, 255); z-index: 10;">
                      <tr>
                        <th class="text-center">#</th>
                        <th>Rut</th>
                        <th>Tipo</th>
                        <th class="text-center">{{ tipo < 200 ? 'Origen' :'Destino'}}</th>
                        <th class="text-center">Relación</th>
                        <th class="text-center">Cant.</th>
                        <th class="text-right">Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let ig of dj_ingreso_gasto_entity_declaration;let indice=index">
                        <td class="text-center">{{((page_info.page_number * page_info.n_per_page) - page_info.n_per_page)+ indice +1}}</td>
                        <td>{{ig.rut}}</td>
                        <td [ngClass]="ig.tipo_ing_egr < 200 ? 'text-success' :'text-danger'">
                          <span class="badge mr-1" [ngClass]="ig.tipo_ing_egr < 200 ? 'badge-success' :'badge-danger'" style="font-size: 0.65rem;">
                            {{ig.tipo_ing_egr}}
                          </span>
                          <span class="small">{{ig.tipo_ing_egr < 200 ? 'Ingreso' : 'Egreso'}}</span>
                        </td>
                        <td class="text-center">{{ig.origen_ing > 0 ? ig.origen_ing : ig.destino_egr }}</td>
                        <td class="text-center">{{ig.tipo_relacion}}</td>
                        <td class="text-center">{{ig.count}}</td>
                        <td class="text-right" [ngClass]="ig.tipo_ing_egr < 200 ? 'text-success' :'text-danger'">
                          ${{ig.total | number:'1.0-0'}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Estado vacío para ingresos/gastos -->
                  <div *ngIf="dj_ingreso_gasto_entity_declaration && dj_ingreso_gasto_entity_declaration.length === 0" class="d-flex flex-column align-items-center justify-content-center text-center" style="height: 300px;">
                    <i class="fa fa-chart-line fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted mb-2">Sin registros</h5>
                    <p class="text-muted mb-0">No hay {{ tipo < 200 ? 'ingresos' : 'egresos' }} registrados</p>
                  </div>
                </div>
                
                <!-- Footer con totales -->
                <div class="p-3" *ngIf="dj_ingreso_gasto_entity_declaration && dj_ingreso_gasto_entity_declaration.length > 0">
                  <div class="d-flex justify-content-between align-items-center rounded p-2">
                    <strong class="text-dark">Total General:</strong>
                    <strong class="text-dark">${{table_total_info.total | number:'1.0-0'}}</strong>
                  </div>
                </div>
                
                <!-- Paginación -->
                <app-table-pagination
                  [pageInfo]="page_info"
                  [loading]="cargando_ingresos"
                  [showRecordsInfo]="true"
                  (pageChange)="changePage($event)"
                  (goToPage)="goToPage($event)">
                </app-table-pagination>
              </div>

              <!-- Tabla de exenciones -->
              <div *ngIf="tipo_dec == 'exenciones'">
                
                <!-- Loading para exenciones (sin scroll) -->
                <div *ngIf="cargando_exenciones" class="border-top border-bottom d-flex flex-column align-items-center justify-content-center" style="height: 500px;">
                  <div class="text-center mb-3">
                    <h5 class="text-primary mb-2 font-weight-normal">Consultando Exenciones</h5>
                    <p class="text-muted mb-0 small">Analizando declaraciones del período...</p>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <div *ngFor="let dot of [1,2,3]; let i = index" 
                         class="pulse-dot pulse-dot-{{dot}} bg-primary rounded-circle"
                         [class.mx-2]="i === 1">
                    </div>
                  </div>
                </div>

                <!-- Contenido de la tabla (con scroll) -->
                <div *ngIf="!cargando_exenciones" class="border-top border-bottom position-relative" style="max-height: 500px; overflow-y: auto;">
                  <!-- Tabla cuando no está cargando -->
                  <table id="excenciones" class="table table-sm table-hover mb-0">
                    <thead style="position: sticky; top: 0; border-bottom: 1px; border-color: black; background: rgb(255, 255, 255); z-index: 10;">
                      <tr>
                        <th class="text-center">#</th>
                        <th>Tipo documento</th>
                        <th>Número</th>
                        <th class="text-center">Año</th>
                        <th>Tipo Exención</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let ex of dec_excenciones;let indice=index">
                        <td class="text-center">{{indice+1}}</td>
                        <td>{{ex.tipo_documento}}</td>
                        <td>{{ex.numero}}</td>
                        <td class="text-center">
                          <span class="badge badge-secondary" style="font-size: 0.65rem;">{{ex.ano}}</span>
                        </td>
                        <td>{{ex.tipo_exencion}}</td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <!-- Estado vacío para exenciones -->
                  <div *ngIf="dec_excenciones && dec_excenciones.length === 0" class="d-flex flex-column align-items-center justify-content-center text-center" style="height: 300px;">
                    <i class="fa fa-shield-alt fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted mb-2">Sin registros</h5>
                    <p class="text-muted mb-0">No hay exenciones registradas</p>
                  </div>
                </div>
                
                <!-- Footer mostrando el total -->
                <div class="p-3" *ngIf="dec_excenciones && dec_excenciones.length > 0">
                  <small class="text-muted">
                    <i class="fa fa-shield-alt text-info"></i>
                    Total de exenciones: <strong>{{ dec_excenciones.length }}</strong>
                  </small>
                </div>
              </div>

              <!-- Tabla de bienes raíces -->
              <div *ngIf="tipo_dec == 'bien_raiz'">
                
                <!-- Loading para bienes raíces (sin scroll) -->
                <div *ngIf="cargando_bienes" class="border-top border-bottom d-flex flex-column align-items-center justify-content-center" style="height: 500px;">
                  <div class="text-center mb-3">
                    <h5 class="text-primary mb-2 font-weight-normal">Consultando Bienes Raíces</h5>
                    <p class="text-muted mb-0 small">Analizando declaraciones del período...</p>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <div *ngFor="let dot of [1,2,3]; let i = index" 
                         class="pulse-dot pulse-dot-{{dot}} bg-primary rounded-circle"
                         [class.mx-2]="i === 1">
                    </div>
                  </div>
                </div>

                <!-- Contenido de la tabla (con scroll) -->
                <div *ngIf="!cargando_bienes" class="border-top border-bottom position-relative" style="max-height: 500px; overflow-y: auto;">
                  <!-- Tabla cuando no está cargando -->
                  <table id="bien_raiz" class="table table-sm table-hover mb-0">
                    <thead style="position: sticky; top: 0; border-bottom: 1px; border-color: black; background: rgb(255, 255, 255); z-index: 10;">
                      <tr>
                        <th class="text-center">#</th>
                        <th>Tipo Sección</th>
                        <th>Ubicación</th>
                        <th>Rol</th>
                        <th>Comuna</th>
                        <th class="text-center">País</th>
                        <th>Uso</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let br of dec_bien_raiz;let indice=index">
                        <td class="text-center">{{indice+1}}</td>
                        <td>{{br.tipo_seccion}}</td>
                        <td>{{br.ubicacion_bien_raiz}}</td>
                        <td>{{br.rol}}</td>
                        <td>{{br.comuna}}</td>
                        <td class="text-center">
                          <span class="badge badge-light" style="font-size: 0.65rem; border: 1px solid #dee2e6;">{{br.pais}}</span>
                        </td>
                        <td>{{br.uso}}</td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <!-- Estado vacío para bienes raíces -->
                  <div *ngIf="dec_bien_raiz && dec_bien_raiz.length === 0" class="d-flex flex-column align-items-center justify-content-center text-center" style="height: 300px;">
                    <i class="fa fa-home fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted mb-2">Sin registros</h5>
                    <p class="text-muted mb-0">No hay bienes raíces registrados</p>
                  </div>
                </div>
                
                <!-- Footer mostrando el total -->
                <div class="p-3" *ngIf="dec_bien_raiz && dec_bien_raiz.length > 0">
                  <small class="text-muted">
                    <i class="fa fa-home text-info"></i>
                    Total de bienes raíces: <strong>{{ dec_bien_raiz.length }}</strong>
                  </small>
                  </div>
                </div>
              
            </div>
          </div>
        </div>
        <!-- end panel-body -->
      </div>
    </div>
  </div>
  <!-- end row -->
  
</div>

<!-- Popup unificado para todas las descargas -->
<div *ngIf="popupConfig.mostrar" class="position-fixed bg-white shadow-lg border download-popup" 
     [style.top.px]="70" 
     [style.right.px]="25" 
     [style.z-index]="9999" 
     [style.width.px]="300"
     [style.border-left]="'4px solid ' + popupConfig.colorPrimario"
     [style.border-radius.px]="8"
     [ngClass]="popupConfig.animacionClase + '-popup'">
  <div class="px-4 py-4">
    <!-- Header elegante -->
    <div class="d-flex align-items-center justify-content-between">
      <!-- Lado izquierdo: Icono y texto -->
      <div class="d-flex align-items-center flex-fill">
        <div class="d-flex align-items-center justify-content-center mr-3" 
             [ngClass]="'bg-' + popupConfig.colorSecundario"
             style="width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0;">
          <i [ngClass]="popupConfig.icono + ' text-white file-bounce'" style="font-size: 1.1rem;"></i>
        </div>
        <div class="flex-fill">
          <h6 class="mb-1 font-weight-bold text-dark">{{popupConfig.titulo}}</h6>
          <small class="text-muted">{{popupConfig.subtitulo}}</small>
        </div>
      </div>
      
      <!-- Lado derecho: Engranajes -->
      <div class="flex-shrink-0 ml-3">
        <div class="d-flex align-items-center justify-content-center" 
             [ngClass]="'bg-' + popupConfig.colorSecundario"
             style="width: 42px; height: 42px; border-radius: 50%;">
          <!-- Estado procesando: Doble engranaje como conjunto centrado -->
          <ng-container *ngIf="popupConfig.procesando !== false">
            <div class="position-relative" style="transform: translateY(4px) translateX(-2px);">
              <!-- Engranaje principal (centrado) -->
              <i class="fas fa-cog gear-spin-main text-white" 
                 style="font-size: 1.3rem;"></i>
              <!-- Engranaje secundario (superpuesto) -->
              <i class="fas fa-cog gear-spin-secondary text-white position-absolute" 
                 style="font-size: 0.9rem; top: -5px; right: -5px; opacity: 0.8;"></i>
            </div>
          </ng-container>
          <!-- Estado completado: Check centrado -->
          <ng-container *ngIf="popupConfig.procesando === false">
            <i class="fas fa-check text-white check-success" 
               style="font-size: 1.6rem; transform: translateY(4px) translateX(-2px);"></i>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>